module.exports = __webpack_public_path__ + "img/logo_cn.e5396055.png";